<template>
    <div class="allbox">
        <div class="swiper-container">
            <div class=swiper-wrapper>
                <div class="swiper-slide page1">
                    <div class="page1_top ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s">
                        <p class="textOne">
                            <span class="whiteText ani" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="1.3s">还</span>
                            <span class="whiteText ani" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="1.6s">记</span>
                            <span class="whiteText ani" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="1.9s">得</span>
                            <span class="whiteText ani" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="2.2s">你</span>
                            <span class="whiteText ani" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="2.5s">和</span>
                        </p>
                        <p class="ani ta" swiper-animate-effect="fadeIn" swiper-animate-delay="2.8s"><img
                                src="../assets/TA@2x.png" alt=""></p>
                    </div>
                    <div class="page1_bottom ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s">
                        <p class="ani xiang" swiper-animate-effect="fadeIn" swiper-animate-delay="3.1s"><img
                                src="../assets/xiang@2x.png" alt=""></p>
                        <p class="ani yu" swiper-animate-effect="fadeIn" swiper-animate-delay="3.4s"><img
                                src="../assets/yu@2x.png" alt=""></p>
                        <p class="textTwo">
                            <span class="ani whiteText" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="3.7s">的</span>
                            <span class="ani whiteText" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="4s">那</span>
                            <span class="ani whiteText" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="4.3s">天</span>
                            <span class="ani whiteText" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="4.6s">吗</span>
                            <span class="ani whiteText" swiper-animate-effect="fadeIn"
                                  swiper-animate-delay="4.9s">？</span>
                        </p>
                        <div class="logo_bown">
                            <p class="logo">
                                <img src="../assets/logo.png" alt="">
                            </p>
                        </div>
                        <div class="dowmBox">
                            <p class="downimg ani" swiper-animate-effect="fadeIn">
                                <img src="../assets/xiangxia.png" alt="">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide page2">
                    <div class="page2top ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s">
                        <p class="ani whiteText shi" swiper-animate-effect="fadeIn" swiper-animate-delay="1.3s">是</p>
                        <p class="ani qing" swiper-animate-effect="fadeIn" swiper-animate-delay="1.6s"><img
                                src="../assets/qing.png" alt=""></p>
                        <p class="tian whiteText">
                            <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="1.9s">天</span>
                            <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="2.2s">，</span>
                        </p>
                    </div>
                    <div class="page2bottom ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s">
                        <div class="text2box">
                            <p class="whiteText haishi">
                                <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="2.5s">还</span>
                                <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="2.8s">是</span>
                            </p>
                            <p class="ani page2_yu" swiper-animate-effect="fadeIn" swiper-animate-delay="3.1s">
                                <img src="../assets/page2_yu.png" alt="">
                            </p>
                            <p class="whiteText tian">
                                <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="3.4s">天</span>
                                <span class="ani" swiper-animate-effect="fadeIn" swiper-animate-delay="3.7s">？</span>
                            </p>
                        </div>
                        <div class="logo_bown">
                            <p class="logo">
                                <img src="../assets/logo.png" alt="">
                            </p>
                        </div>
                        <div class="dowmBox">
                            <p class="downimg ani" swiper-animate-effect="fadeIn">
                                <img src="../assets/xiangxia.png" alt="">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide page3" style="position: relative">
                    <div class="bgbox">
                        <div class="title">
                            <img src="../assets/biaoti.png" alt="">
                        </div>
                        <div class="yourname input">
                            <input type="text" class="youmameinp" placeholder="请输入你的昵称" v-model="yourname"
                                   maxlength="5">
                        </div>
                        <div class="hesname input">
                            <input type="text" class="hesnameinp" placeholder="请输入他的昵称" v-model="hesname" maxlength="5">
                        </div>
                        <div class="address input">
                            <div class="sheng">
                                <select v-model="addressIndex" @change="shengChange">
                                    <option value="请选择">请选择</option>
                                    <option v-for="(item,index) in addresslist" :value="index" :key="index+'llll'">
                                        {{item.name}}
                                    </option>
                                </select>
                                <!--                                <span> <img src="../assets/xiasanjiao.png" alt=""></span>-->
                            </div>
                            <div class="shi">
                                <select v-model="shiVal" id="shi_List" @change="shiChange">
                                    <option value="请选择">请选择</option>
                                    <option v-for="(item,index) in shiList"
                                            :value="{city_id:item.city_id,province_id:item.province_id,name:item.city}"
                                            :key="index+'oooo'">{{item.city}}
                                    </option>
                                </select>
                                <!--                                <span> <img src="../assets/xiasanjiao.png" alt=""></span>-->
                            </div>
                        </div>
                        <div class="day input">
                            <div id="birthday_container">
                                <select name="year" v-model="date.date_y" id="yselect" :style="iosPadding"></select>
                                <!--                                <span>{{date.date_y}}</span>-->
                                <!--                                <span>     </span>-->
                                <select name="month" v-model="date.date_m" id="mselect" :style="iosPadding"></select>
                                <!--                                <span>{{date.date_m}}</span>-->
                                <!--                                <span>     </span>-->
                                <select name="day" v-model="date.date_d" id="dselect" :style="iosPadding"></select>
                                <!--                                <span>{{date.date_m}}</span>-->
                                <!--                                <span>     </span>-->
                            </div>
                        </div>
                        <div class="button input">
                            <button type="button" @click="getwheater" id="button_1" :class="aniclass"
                                    swiper-animate-effect="jackInTheBox" swiper-animate-duration="1s">开启时光穿梭
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let swi_this = null
    export default {
        name: 'index',
        data() {
            return {
                addresslist: '',
                addressIndex: '请选择',
                shiList: [],
                shiVal: '请选择',
                date: {
                    date_y: '2019',
                    date_m: '1',
                    date_d: '1',
                },
                yourname: '',
                hesname: '',
                aniclass: '',
                iosPadding: ''
            }
        },
        mounted() {
            if (this.$route.query.type == 'qrcode') {
                zhuge.track("天气之子异业合作", {
                    '扫码进入H5的PVUV': "h5_weatherson_scan_sc"
                });
                // console.log(JSON.stringify({
                //     '扫码进入H5的PVUV': "h5_weatherson_scan_sc"
                // }))
            }

            if (this.isIOS) {
                this.iosPadding = {paddingLeft: '.17rem'}
            }
            // $('#birthday_container').birthday()
            /**
             * @name swiper 初始化
             * @type {default}
             * @private
             */
            let _this = this
            let myswiper = new this.$swiper('.swiper-container', {
                direction: 'vertical',
                on: {
                    init() {
                        swiperAnimateCache(this) //隐藏动画元素
                        swiperAnimate(this) //初始化完成开始动画
                        swi_this = this
                    },
                    slideChangeTransitionEnd: function () {
                        swiperAnimate(this)
                        _this.$(this.slides).eq(this.activeIndex).find('.ani').removeClass('ani')
                    }
                }
            })

            /**
             * @name 日期选择器初始化
             */
            setTimeout(() => {
                $('#birthday_container').DateSelector({
                    ctlYearId: 'yselect',
                    ctlMonthId: 'mselect',
                    ctlDayId: 'dselect',
                    defYear: 2019,
                    defMonth: 1,
                    defDay: 1,
                    minYear: 1990
                    // dateChanged: 日期修改后事件,function(yearSelect,monthSelect,daySelect){}
                })
            }, 500)

            /**
             * 省市联动数据处理
             */
            //城市数据
            this.$axios({
                method: 'get',
                url: './data/city.json'
            }).then(res => {
                this.addresslist = res.data
            })


            document.body.addEventListener('focusout', () => { //软键盘关闭事件
                window.scrollTo(0, 0);
            })

        },
        methods: {
            /**
             * 省市联动-省改变
             */
            shengChange() {
                this.shiList = this.addresslist[this.addressIndex].children
                setTimeout(() => {
                    this.$('#shi_List>option:first').prop('selected', 'selected')
                })
            },
            /**
             * 省市联动-市改变
             */
            shiChange() {
                console.log(this.shiVal)
            },

            /**
             * @name 获取天气数据
             */
            getwheater() {
                zhuge.track('天气之子异业合作', {
                    '开启时光穿梭按钮点击': 'h5_weatherson_start_ck'
                })
                console.log(JSON.stringify(
                    {'开启时光穿梭按钮点击': 'h5_weatherson_start_ck'}))
                this.$loading.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                })
                this.aniclass = 'ani'
                let m = ''
                if (this.date.date_m.length === 1) {
                    m = '0' + this.date.date_m
                } else {
                    m = this.date.date_m
                }
                let d = ''
                if (this.date.date_d.length === 1) {
                    d = '0' + this.date.date_d
                } else {
                    d = this.date.date_d
                }

                if (this.yourname === '') {
                    this.$loading.close()

                    this.$alert({
                        message: '请输入你的昵称',
                        position: 'middle',
                        duration: 2000
                    })
                    return
                } else if (this.yourname.length > 5 || this.hesname.length > 5) {
                    this.$loading.close()

                    this.$alert({
                        message: '昵称最长5个字符哦',
                        position: 'middle',
                        duration: 2000
                    })
                    return
                } else if (this.hesname === '') {
                    this.$loading.close()
                    this.$alert({
                        message: '请输入TA的昵称',
                        position: 'middle',
                        duration: 2000
                    })
                    return
                } else if (this.addressIndex === '请选择' || this.shiVal === '请选择') {
                    this.$loading.close()
                    this.$alert({
                        message: '请选择相遇地点',
                        position: 'middle',
                        duration: 2000
                    })
                    return;
                }
                let _this = this;
                let nowDate = new Date().getTime()
                let checkDate = new Date(_this.date.date_y+'-'+_this.date.date_m+'-'+_this.date.date_d).getTime();
                if(nowDate < checkDate){
                    this.$alert({
                        message: '选择的时间应小于当前时间',
                        position: 'middle',
                        duration: 2000
                    })
                }

                $.ajax({
                    dataType: 'jsonp',
                    url: process.env.VUE_APP_API_URL + 'api/dun/checkMessageJson',
                    method: 'get',
                    data: {
                        'json': JSON.stringify([this.yourname, this.hesname])
                    },
                    success: (res) => {
                        if (res.data[0].action != 0) {
                            this.$loading.close()

                            this.$alert({
                                message: '你的昵称包含敏感词',
                                position: 'middle',
                                duration: 2000
                            })
                            return
                        } else if (res.data[1].action != 0) {
                            this.$loading.close()

                            this.$alert({
                                message: 'TA的昵称包含敏感词',
                                position: 'middle',
                                duration: 2000
                            })
                            return
                        } else {
                            //获取天气信息
                            $.ajax({
                                url: process.env.VUE_APP_API_URL + 'api/weatheringwithyou/getWeather',
                                method: 'get',
                                dataType: 'jsonp',
                                data: {
                                    city_id: this.shiVal.city_id,
                                    province_id: this.shiVal.province_id,
                                    day: this.date.date_y + '' + m + '' + d
                                },
                                success: (res) => {
                                    this.$loading.close()

                                    setTimeout(() => {
                                        swiperAnimate(swi_this)
                                    })

                                    setTimeout(() => {
                                        this.$router.push({
                                            path: '/result',
                                            name: 'result',
                                            query: {
                                                name1: this.yourname,
                                                name2: this.hesname,
                                                qnum: res.data.history['0'],
                                                ynum: res.data.history['2'],
                                                todayweather: res.data['today'],
                                                year: this.date.date_y,
                                                mounth: m,
                                                day: d,
                                                city: this.shiVal.name
                                            }
                                        })
                                    })
                                }
                            })
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    input:focus::placeholder {
        color: rgba(0, 0, 0, 0) !important;
    }

    .allbox {
        width: 100%;
        height: 100%;

        .swiper-container {
            width: 100%;
            height: 100%;

            .swiper-slide {
                width: 100%;
                height: 100%;
            }

            .page1 {
                & > div {
                    position: relative;
                }

                .whiteText {
                    font-size: .18rem;
                    color: #fff;
                    letter-spacing: 4px;
                }

                .page1_top {
                    width: 100%;
                    height: 47%;
                    background: url("../assets/page1top_bg.png") no-repeat;
                    background-size: cover;

                    .textOne {
                        position: absolute;
                        left: .47rem;
                        bottom: .21rem;
                    }

                    .ta {
                        position: absolute;
                        bottom: .08rem;
                        left: 1.6rem;
                        width: .39rem;

                        img {
                            width: 100%;
                        }
                    }
                }

                .page1_bottom {
                    width: 100%;
                    height: 53%;
                    background: url("../assets/page1bottom_bg.png") no-repeat;
                    background-size: cover;
                    position: relative;

                    .xiang {
                        position: absolute;
                        left: 1.65rem;
                        width: .4rem;
                        top: .1rem;

                        img {
                            width: 100%;
                        }
                    }

                    .yu {
                        width: .245rem;
                        position: absolute;
                        top: .415rem;
                        left: 1.95rem;

                        img {
                            width: 100%;
                        }
                    }

                    .textTwo {
                        position: absolute;
                        left: 2.24rem;
                        top: .3rem;
                    }

                    .logo_bown {
                        width: 100%;
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        bottom: .1rem;

                        .logo {
                            width: 80%;

                            img {
                                width: 100%;
                            }
                        }
                    }

                    .dowmBox {
                        width: 100%;
                        display: flex;
                        position: absolute;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        bottom: .25rem;

                        .downimg {
                            animation-iteration-count: infinite !important;
                            width: .25rem;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            .page2 {
                .page2top {
                    width: 100%;
                    height: 47%;
                    background: url("../assets/page2_top_bg.png") no-repeat;
                    background-size: cover;
                    position: relative;

                    .shi {
                        position: absolute;
                        bottom: .14rem;
                        left: .885rem
                    }

                    .qing {
                        position: absolute;
                        bottom: .06rem;
                        left: 1.13rem;
                        width: .4rem;

                        img {
                            width: 100%;
                        }
                    }

                    .tian {
                        position: absolute;
                        bottom: .14rem;
                        left: 1.565rem;
                    }
                }

                .whiteText {
                    font-size: .18rem;
                    color: #fff;
                    letter-spacing: 4px;
                }

                .page2bottom {
                    width: 100%;
                    height: 53%;
                    background: url("../assets/page2_bottom_bg.png") no-repeat;
                    background-size: cover;
                    position: relative;

                    .haishi {
                        position: absolute;
                        left: 1.605rem;
                        top: .235rem;
                    }

                    .page2_yu {
                        width: .36rem;

                        img {
                            width: 100%;
                        }

                        position: absolute;
                        top: .11rem;
                        left: 2.095rem;
                    }

                    .tian {
                        position: absolute;
                        top: .235rem;
                        left: 2.54rem;
                    }

                    .logo_bown {
                        width: 100%;
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        bottom: .1rem;

                        .logo {
                            width: 80%;

                            img {
                                width: 100%;
                            }
                        }
                    }

                    .dowmBox {
                        width: 100%;
                        display: flex;
                        position: absolute;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        bottom: .25rem;

                        .downimg {
                            animation-iteration-count: infinite !important;
                            width: .25rem;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            .page3 {
                display: flex;
                justify-content: center;
                width: 100%;
                height: 100%;
                background: url("../assets/page3_bg.png") no-repeat;
                background-size: cover;

                .bgbox {
                    & > div {
                        margin-bottom: .18rem;
                    }

                    .input {
                        width: 2.73rem;
                        height: .66rem;
                    }

                    .title {
                        width: 2.52rem;
                        padding-top: .69rem;

                        img {
                            width: 108%;
                        }
                    }

                    .yourname {
                        background: url("../assets/nidemingcheng.png") no-repeat;
                        background-size: 100%;
                        display: flex;
                        justify-content: center;
                        padding-top: .2rem;

                        input {
                            width: 2.5rem;
                            height: .4rem;
                            border: none;
                            background: #fff;
                            outline: none;
                            padding-left: .155rem;
                            font-size: .16rem;
                            color: #7b8092;
                        }
                    }

                    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
                        font-size: .16rem;
                        color: #7b8092;
                    }

                    .hesname {
                        background: url("../assets/tadenicheng.png") no-repeat;
                        background-size: 100%;
                        display: flex;
                        justify-content: center;
                        padding-top: .2rem;

                        input {
                            width: 2.5rem;
                            height: .4rem;
                            border: none;
                            background: #fff;
                            outline: none;
                            padding-left: .155rem;
                            font-size: .16rem;
                            color: #7b8092;
                        }
                    }

                    .address {
                        background: url("../assets/difang.png") no-repeat;
                        background-size: 100%;
                        display: flex;
                        justify-content: space-between;
                        padding-top: .2rem;
                        padding-left: .1rem;
                        padding-right: .1rem;
                        font-size: 0;

                        & > div {
                            width: 45%;
                            height: .4rem;
                            background: white;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 .1rem;
                            /*display: flex;*/

                            img {
                                width: .1rem;
                            }

                            select {
                                outline: none;
                                width: 100%;
                                height: 100%;
                                appearance: none;
                                -moz-appearance: none;
                                -webkit-appearance: none;
                                color: #7b8092;
                                border: none;
                                font-size: .16rem;
                                background: url("../assets/xiasanjiao.png") no-repeat;
                                background-size: 10px;
                                background-position-x: right;
                                background-position-y: center;
                                padding-right: .1rem;

                                option {
                                    width: 100%;
                                }
                            }
                        }

                    }

                    .day {
                        background: url("../assets/natian.png") no-repeat;
                        background-size: 100%;
                        padding-top: .2rem;
                        padding-left: .1rem;
                        padding-right: .1rem;

                        & > div {
                            background: #fff;
                            padding: 0 .1rem;

                            font-size: 0;
                            /*background: #ffffff;*/

                            select {
                                outline: none;
                                width: 30%;
                                height: 100%;
                                appearance: none;
                                -moz-appearance: none;
                                -webkit-appearance: none;
                                text-align: center;
                                color: #7b8092;
                                border: none;
                                font-size: .16rem;
                                background: url("../assets/xiasanjiao.png") no-repeat;
                                background-size: 10px;
                                background-position-x: right;
                                background-position-y: center;
                                text-align-last: center;
                                padding-right: .1rem;
                                /*opacity: 0;*/
                            }

                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            height: .4rem;

                            & > span {
                                display: inline-block;
                                padding-right: .15rem;
                            }

                            img {
                                width: .1rem
                            }
                        }
                    }

                    .button {
                        display: flex;
                        justify-content: center;
                        padding-top: .2rem;

                        button {
                            width: 1.85rem;
                            height: .4rem;
                            background: rgba(0, 0, 0, .7);
                            color: #fff;
                            font-size: .18rem;
                            border-radius: 5px;
                            outline: none;
                            border: none;
                        }
                    }
                }
            }
        }
    }
</style>